module.exports = __webpack_public_path__ + "static/media/logo.45210713.svg";